<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Assureurs / Assurances à centraliser</div>
  <div cardRows class="card__rows w-100">
    <div class="flex-basis-100">
      <div class="card__row" *ngFor="let element of insurerTrackingInfo">
        <span class="card__label" i18n>{{ getInsurerLabel(element) }}</span>
        <div class="card__value">
          <ng-container
            *ngFor="let insuranceElement of element.insurances; last as isLast"
          >
            <div class="form-check">
              <label
                class="form-check-label strong-text"
                [ngClass]="{
                  'new-lead-value':
                    originalMetadata?.trackingInfo &&
                    !hasSameTrackingElement(
                      element,
                      originalMetadata?.trackingInfo
                    ),
                }"
                [for]="getTrackingKey(element) + insuranceElement.insurance"
              >
                {{ getInsuranceTypeLabel(insuranceElement.insurance) }}
              </label>
            </div>
          </ng-container>
        </div>
      </div>
      <div
        class="card__row"
        *ngFor="let element of originalMetadata?.trackingInfo"
      >
        <span class="card__label"></span>
        <div class="card__value">
          <ng-container
            *ngIf="
              metadata?.trackingInfo &&
              !hasSameTrackingElement(element, metadata?.trackingInfo)
            "
          >
            <ng-container *ngFor="let insuranceElement of element.insurances">
              <div class="form-check">
                <label class="form-check-label old-lead-value">
                  {{ getInsuranceTypeLabel(insuranceElement.insurance) }}
                </label>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</app-card>
